import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { ManagementResult, ManagementStatistic } from '@thiememeulenhoff/types';

export const managementResults = createStore(
  { name: 'managementResults' },
  withEntities<ManagementResult, 'identifier'>({
    idKey: 'identifier',
  }),
);

export const managementStatistics = createStore(
  { name: 'managementStatistics' },
  withEntities<ManagementStatistic, 'identifier'>({
    idKey: 'identifier',
  }),
);
